import React from 'react';
import { Container, ButtonContainer } from './styled';
import MenuButton from './MenuButton';
import { Hr } from '../../styled';
import BoardIcon from '@mui/icons-material/Dashboard';
import BackgroundIcon from '@mui/icons-material/Wallpaper';
import ActivitySection from './ActivitySection/ActivitySection';
const MainMenu = (props) => {
	return (
		<Container>
			<ButtonContainer>
				<MenuButton
					icon={<BoardIcon fontSize='small' color='inherit'/>}
					title='Sobre este quadro'
					description='Adicione uma descrição ao seu quadro'
					clickCallback={()=>props.menuCallback('Sobre este quadro')}
				/>
				<MenuButton
					icon={<BackgroundIcon fontSize='small' color='inherit'/>}
					title='Alterar plano de fundo'
					description='Mude o plano de fundo do seu quadro'
					clickCallback={()=>props.menuCallback('Alterar plano de fundo')}
				/>
			</ButtonContainer>
			<Hr />
			<ActivitySection />
		</Container>
	);
};

export default MainMenu;
